import "@lighting-beetle/lighter-styleguide/build/lib/polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { MDXProvider } from "@mdx-js/react";
import {
  App as StyleguideApp,
  MDXComponents,
} from "@lighting-beetle/lighter-styleguide";

import "./styles/before-components.scss";

import config from "./project.config";
import routes from "./styleguide/routes";

import "./styles/after-components.scss";

// styleguide({ config, routes });

// if MDXProvider is inside <App /> in styleguide dependency
// context is not shared between MDXProvider and .mdx pages
// Thats why we need to declare MDXProvider here
// with styleguide MDXComponents.
// Could this be problem with MDX compiler not seeing right context?
ReactDOM.render(
  <MDXProvider components={MDXComponents}>
    <StyleguideApp config={config} routes={routes} />
  </MDXProvider>,
  document.getElementById("root")
);
